function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null);

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var SvgHistoryBlue = function SvgHistoryBlue(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 503.607 503.607",
    style: {
      enableBackground: "new 0 0 503.607 503.607"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("circle", {
    style: {
      fill: "#A4C2F7"
    },
    cx: 251.803,
    cy: 251.794,
    r: 243.41
  }), React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -52.9534,
    y1: 651.5421,
    x2: -52.2268,
    y2: 650.8531,
    gradientTransform: "matrix(461.6393 0 0 -486.8196 24517.0957 317267.8125)"
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.1717,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.2,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.2001,
    style: {
      stopColor: "#DAE4F4"
    }
  }), React.createElement("stop", {
    offset: 0.2007,
    style: {
      stopColor: "#EBEBF4"
    }
  }), React.createElement("stop", {
    offset: 0.2014,
    style: {
      stopColor: "#F6F1F4"
    }
  }), React.createElement("stop", {
    offset: 0.2023,
    style: {
      stopColor: "#FDF4F4"
    }
  }), React.createElement("stop", {
    offset: 0.205,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.2522,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.26,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.3974,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.42,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.4201,
    style: {
      stopColor: "#DAE4F4"
    }
  }), React.createElement("stop", {
    offset: 0.4207,
    style: {
      stopColor: "#EBEBF4"
    }
  }), React.createElement("stop", {
    offset: 0.4214,
    style: {
      stopColor: "#F6F1F4"
    }
  }), React.createElement("stop", {
    offset: 0.4223,
    style: {
      stopColor: "#FDF4F4"
    }
  }), React.createElement("stop", {
    offset: 0.425,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.4894,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "#F9F2F4"
    }
  }), React.createElement("stop", {
    offset: 0.5001,
    style: {
      stopColor: "#E8EBF4"
    }
  }), React.createElement("stop", {
    offset: 0.5003,
    style: {
      stopColor: "#DDE5F4"
    }
  }), React.createElement("stop", {
    offset: 0.5005,
    style: {
      stopColor: "#D6E2F4"
    }
  }), React.createElement("stop", {
    offset: 0.501,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.7062,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.74,
    style: {
      stopColor: "#D4E1F4"
    }
  }), React.createElement("stop", {
    offset: 0.741,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.8346,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.85,
    style: {
      stopColor: "#FFF5F4"
    }
  }), React.createElement("stop", {
    offset: 0.851,
    style: {
      stopColor: "#D4E1F4"
    }
  })), React.createElement("ellipse", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    cx: 239.213,
    cy: 251.794,
    rx: 230.82,
    ry: 243.41
  }), React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M251.803,495.215c2.168,0,4.308-0.107,6.462-0.164C133.629,491.615,33.574,384.07,33.574,251.805 S133.629,11.996,258.265,8.559c-2.154-0.057-4.295-0.164-6.462-0.164c-134.432,0-243.41,108.978-243.41,243.41 S117.372,495.215,251.803,495.215z"
  }), React.createElement("circle", {
    style: {
      fill: "#A4C2F7"
    },
    cx: 251.803,
    cy: 250.787,
    r: 25.18
  }), React.createElement("g", null, React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M251.803,503.607C112.736,503.607,0,390.87,0,251.803S112.736,0,251.803,0 s251.803,112.736,251.803,251.803C503.449,390.805,390.805,503.449,251.803,503.607z M251.803,16.787 c-129.796,0-235.016,105.22-235.016,235.016S122.007,486.82,251.803,486.82S486.82,381.599,486.82,251.803 C486.674,122.068,381.539,16.932,251.803,16.787z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M226.623,259.18h-67.148c-4.636,0-8.393-3.758-8.393-8.393c0-4.636,3.758-8.393,8.393-8.393h67.148 c4.636,0,8.393,3.758,8.393,8.393C235.016,255.422,231.258,259.18,226.623,259.18z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M251.803,234c-2.226,0.001-4.362-0.884-5.936-2.458c-1.574-1.574-2.458-3.709-2.458-5.936v-92.328 c0-4.636,3.758-8.393,8.393-8.393s8.393,3.758,8.393,8.393v92.328c0.001,2.226-0.884,4.361-2.458,5.936 C256.165,233.116,254.03,234.001,251.803,234L251.803,234z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M251.803,284.361c-18.542,0-33.574-15.031-33.574-33.574c0-18.542,15.031-33.574,33.574-33.574 s33.574,15.031,33.574,33.574C285.357,269.321,270.337,284.341,251.803,284.361z M251.803,234 c-9.271,0-16.787,7.516-16.787,16.787c0,9.271,7.516,16.787,16.787,16.787c9.271,0,16.787-7.516,16.787-16.787 C268.58,241.52,261.07,234.011,251.803,234L251.803,234z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M251.803,82.918c-2.226,0.001-4.362-0.884-5.936-2.458c-1.574-1.574-2.458-3.709-2.458-5.936 v-8.393c0-4.636,3.758-8.393,8.393-8.393s8.393,3.758,8.393,8.393v8.393c0.001,2.226-0.884,4.361-2.458,5.936 C256.165,82.035,254.03,82.919,251.803,82.918z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M251.803,443.836c-2.226,0.001-4.362-0.884-5.936-2.458c-1.574-1.574-2.458-3.709-2.458-5.936 v-8.393c0-4.636,3.758-8.393,8.393-8.393s8.393,3.758,8.393,8.393v8.393c0.001,2.226-0.884,4.361-2.458,5.936 C256.165,442.953,254.03,443.837,251.803,443.836L251.803,443.836z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M436.459,259.18h-8.393c-4.636,0-8.393-3.758-8.393-8.393c0-4.636,3.758-8.393,8.393-8.393h8.393 c4.636,0,8.393,3.758,8.393,8.393C444.852,255.422,441.095,259.18,436.459,259.18z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M75.541,259.18h-8.393c-4.636,0-8.393-3.758-8.393-8.393c0-4.636,3.758-8.393,8.393-8.393h8.393 c4.636,0,8.393,3.758,8.393,8.393C83.934,255.422,80.177,259.18,75.541,259.18z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M376.439,134.541c-3.394-0.001-6.454-2.046-7.753-5.182c-1.299-3.136-0.581-6.745,1.819-9.146 l5.934-5.934c2.12-2.12,5.21-2.948,8.107-2.172c2.896,0.776,5.158,3.038,5.934,5.934c0.776,2.896-0.052,5.986-2.172,8.107 l-5.934,5.934C380.801,133.659,378.665,134.544,376.439,134.541z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M121.234,389.754c-3.394-0.001-6.454-2.046-7.753-5.182s-0.581-6.745,1.819-9.146l5.934-5.934 c3.277-3.277,8.591-3.277,11.869,0c3.277,3.277,3.277,8.591,0,11.869l-5.934,5.934 C125.596,388.872,123.46,389.757,121.234,389.754L121.234,389.754z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M382.373,389.754c-2.226,0.003-4.362-0.883-5.934-2.459l-5.934-5.934 c-3.277-3.277-3.277-8.591,0-11.869c3.277-3.277,8.591-3.277,11.869,0l5.934,5.934c2.4,2.4,3.117,6.01,1.819,9.146 C388.827,387.708,385.768,389.753,382.373,389.754L382.373,389.754z"
  }), React.createElement("path", {
    style: {
      fill: "#428DFF"
    },
    d: "M127.168,134.541c-2.226,0.003-4.362-0.883-5.934-2.459l-5.934-5.934 c-3.277-3.277-3.277-8.591,0-11.869c3.277-3.277,8.591-3.277,11.869,0l5.934,5.934c2.4,2.4,3.118,6.01,1.819,9.146 C133.623,132.495,130.563,134.54,127.168,134.541L127.168,134.541z"
  }))), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgHistoryBlue, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/history-blue.6ab20e50.svg";
export { ForwardRef as ReactComponent };